import { Box, Chip } from "@mui/material";

const ChipTaskProps = {
  green: {
    dotSxProps: {
      backgroundColor: "#00C853",
    },
    chipSxProps: {
      backgroundColor: "#ECFDF3",
      color: "#027A48",
    },
  },
  orange: {
    dotSxProps: {
      backgroundColor: "#EF6820",
    },
    chipSxProps: {
      backgroundColor: "#FFF4ED",
      color: "#B93815",
    },
  },
};

export const ChipTaskStatus = ({
  label,
  color,
}: {
  label: string;
  color: "green" | "orange";
}) => {
  return (
    <Chip
      icon={
        <Box
          sx={{
            ml: "12px !important",
            width: "8px !important",
            height: "8px !important",
            borderRadius: "50%",
            ...ChipTaskProps[color].dotSxProps,
          }}
        />
      }
      sx={{
        ...ChipTaskProps[color].chipSxProps,
      }}
      label={label}
    />
  );
};
